export const percentageFormat = new Intl.NumberFormat('el-GR', {
	style: 'percent',
	maximumFractionDigits: 0
});
